<!--
 * @Description: 编辑地图弹窗
 * @Author: mdb
 * @Date: 2023-05-08 10:43:50
 * @LastEditTime: 2023-05-19 13:50:15
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :width="600"
    title="编辑"
    :confirmLoading="loading"
    destroyOnClose
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }" ref="formRef" :model="dataForm">
      <a-form-item label="操作系统" name="osType" :rules="formRules.select">
        <a-select v-model:value="dataForm.osType" :options="mapsEnum" disabled />
      </a-form-item>
      <a-form-item label="当前版本" name="currVersion" :rules="formRules.input">
        <CosInput v-model:value="dataForm.currVersion" placeholder="请输入" :maxlength="100" />
      </a-form-item>
      <a-form-item label="最小版本号" name="minVersion" :rules="formRules.input">
        <CosInputNumber
          v-model:value="dataForm.minVersion"
          placeholder="请输入"
          :max="dataForm.maxVersion"
          :maxlength="100"
        />
      </a-form-item>
      <a-form-item label="最大版本号" name="maxVersion" :rules="formRules.input">
        <CosInputNumber v-model:value="dataForm.maxVersion" placeholder="请输入" :maxlength="100" />
      </a-form-item>
      <a-form-item label="升级内容" name="content" :rules="formRules.input">
        <CosTextarea v-model:value="dataForm.content" placeholder="请输入" :maxlength="100" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { updateAppVersion } from '@/api/systemSetting/index'
import type { AppVersionItem } from '@/typings/api/systemSetting'

const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = ref<AppVersionItem>({})
const formRules = reactive({
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }]
})
const emit = defineEmits(['fetch'])
// 弹窗标题
const init = (rows: AppVersionItem) => {
  dataForm.value = {
    ...rows
  }
  visible.value = true
}

const handleOk = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    try {
      await updateAppVersion(dataForm.value)
      DcMessage.success('操作成功！')
      emit('fetch')
      handleCancel()
    } finally {
      loading.value = false
    }
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
  visible.value = false
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ModalForm' }
</script>
